// Production is open to customers for Authorization only, for now.
// shortcut: this closes the pages, the API still answers a signed-in caller; gate the routes in traceira-backend if that must hold too.
const LOCKED_HOSTS = ['scan.traceira.com', 'traceira-frontend-production.up.railway.app'];
// What reaching Authorization takes: signing in, setup, picking a workspace, and the letter pages.
const OPEN_PATHS = /^\/(authorization|owner|verify|setup|sign-in|workspaces)(\/|$)/;

export const authorizationOnly = () => LOCKED_HOSTS.includes(window.location.hostname);
export const closedPage = (pathname: string) => authorizationOnly() && !OPEN_PATHS.test(pathname);
